<template>
  <v-dialog
    v-model="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    max-width="1200"
    :retain-focus="false"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular mb-3"
        ><v-flex>
          <v-icon
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            class="mr-3"
            medium
            >mdi-bell-check-outline</v-icon
          >
          {{ $t("appConfirmationsTitle") }}
        </v-flex>
      </v-card-title>

      <v-card-text>
        <v-expansion-panels accordion flat>
          <v-expansion-panel
            class="pt-1"
            v-show="
              this.$store.state.storeClient.client.rulesAndSecurityInfo
                .showPrivacyInfo &&
              !this.$store.state.storeAuth.userProfile.allowPrivacy
            "
          >
            <v-expansion-panel-header style="border: 1px solid lightgray">
              {{ $t("appConfirmationsPrivacyTitle") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content
              class="pa-2"
              v-html="
                $store.state.storeClient.client.rulesAndSecurityInfo.privacyHTML.replace(
                  /(?:\r\n|\r|\n)/g,
                  '<br />'
                )
              "
            >
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel
            class="pt-1"
            v-show="
              this.$store.state.storeClient.client.rulesAndSecurityInfo
                .showRulesInfo &&
              !this.$store.state.storeAuth.userProfile.allowRules
            "
          >
            <v-expansion-panel-header style="border: 1px solid lightgray">
              {{ $t("appConfirmationsRulesTitle") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content
              class="pa-2"
              v-html="
                $store.state.storeClient.client.rulesAndSecurityInfo.rulesHTML.replace(
                  /(?:\r\n|\r|\n)/g,
                  '<br />'
                )
              "
            >
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel
            class="pt-1"
            v-show="
              this.$store.state.storeClient.client.rulesAndSecurityInfo
                .showCookiesInfo &&
              !this.$store.state.storeAuth.userProfile.allowCookies
            "
          >
            <v-expansion-panel-header style="border: 1px solid lightgray">
              {{ $t("appConfirmationsCookiesTitle") }}
            </v-expansion-panel-header>
            <v-expansion-panel-content
              class="pa-2"
              v-html="
                $store.state.storeClient.client.rulesAndSecurityInfo.cookiesHTML.replace(
                  /(?:\r\n|\r|\n)/g,
                  '<br />'
                )
              "
            >
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>

      <v-card-actions
        class="mt-3"
        :class="getTheme() == 'dark' ? '#505050--text' : '#505050--text'"
        :style="
          getTheme() == 'dark'
            ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
            : 'background-color: white; border-top: 1px solid lightgray;'
        "
      >
        <v-spacer></v-spacer>
        <v-btn color="primary" text class="mx-0" @click="clickNo">{{
          $t("lmBtnSignOut")
        }}</v-btn>
        <v-btn color="primary" class="mx-0 ml-4" @click="clickYes">{{
          $t("lmBtnAgree")
        }}</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "dialog-confirmations",
  props: {
    active: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    clickYes: function () {
      this.$emit("clickYes");
    },
    clickNo: function () {
      this.$emit("clickNo");
    },
  },
};
</script>

<style scoped>
</style>